import { HttpService } from '@services/http.service';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { StringDto } from '@models/basic/string-dto';
import { EndpointParams } from '@models/utils/endpoint-params';

@Injectable({
    providedIn: 'root'
})
export class AccountService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'member', version: 1 };

    confirmValidate(jwtString: StringDto, publicToken: string): Observable<any> {
        const url = `account/validate/confirm?centerToken=${publicToken}`;

        return this.post(url, this.defaultEndpointParams, jwtString);
    }

    sendValidate(): Observable<any> {
        const url = 'account/validate/send';

        return this.post(url, this.defaultEndpointParams);
    }

    sendValidateExternal(jwt: StringDto, publicToken: string): Observable<any> {
        const url = `account/validate/send/external?centerToken=${publicToken}`;

        return this.post(url, this.defaultEndpointParams, jwt);
    }
}
